import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import Spinners from "../Spinner";
import { isEmpty, isString, isPlainObject } from "lodash";

const DataMessageHandler = memo(
  ({
    data = [],
    isLoading = false,
    filterClick = true,
    children,
    spinnerClassName = "",
    noDataClassName = "",
    customMessage = "",
  }) => {
    const { showData, processedData, messageToDisplay } = useMemo(() => {
      const configureNotHappen =
        Array.isArray(data) &&
        data.length === 1 &&
        isString(data[0]?.message);

      const isErrorResponse =
        data?.constructor === Object &&!Array.isArray(data) &&
        ("status" in data || "error" in data);

      // empty data checks
      const isEmptyData =
        data == null ||
        isEmpty(data) ||
        (Array.isArray(data) && data.length === 0) ||
        (data?.constructor === Object && Object.keys(data).length === 0) ||
        (isString(data) && data.trim() === "") ||
        (data?.data && Array.isArray(data.data) && data.data.length === 0);

      // Determine the message to display
      const message = configureNotHappen
        ? data[0].message
        : customMessage || "No Data Available";

      const hasValidData =
        !isEmptyData && !configureNotHappen && !isErrorResponse;

      return {
        showData: hasValidData,
        processedData: hasValidData ? data : [],
        messageToDisplay: message,
      };

    }, [data, customMessage]);

    if (!filterClick) {
      return null;
    }

    if (isLoading) {
      return <Spinners className={spinnerClassName} />;
    }

    if (showData) {
      return typeof children === "function"
        ? children(processedData)
        : children;
    }

    return (
      <div
        className={`NodataAvailableVMTDD NodataAvailable ${noDataClassName || ""
          }`}
      >
        {messageToDisplay}
      </div>
    );
  }
);

DataMessageHandler.displayName = "DataMessageHandler";

DataMessageHandler.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  isLoading: PropTypes.bool,
  filterClick: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  spinnerClassName: PropTypes.string,
  noDataClassName: PropTypes.string,
  customMessage: PropTypes.string,
};

export default DataMessageHandler;
